/* eslint-disable react/prop-types */
import React, { createContext, useContext } from 'react';

const TranslationContext = createContext(false);

export function NoTranslate({ children }) {
  return (
    <TranslationContext.Provider value={true}>
      {children}
    </TranslationContext.Provider>
  );
}

export const useTranslationDisabled = () => useContext(TranslationContext);

export default TranslationContext;
